export default __webpack_public_path__ + "static/media/meme.0729653b.mp3";